import React, { memo } from "react";
import * as URLConfig from "@frameworks/web/config/domain";
import _ from "underscore";
var ChartIq = function (props) {
    var config = URLConfig.config;
    return (React.createElement("iframe", { className: "graph-chart   ".concat(props.parentClass), id: "chartiq", src: "".concat(config.tradingviewBase, "?instru=").concat(props === null || props === void 0 ? void 0 : props.instru, "&sym=").concat(props === null || props === void 0 ? void 0 : props.symbol, "&chttype=snap"), sandbox: "allow-scripts allow-same-origin" }));
};
export default memo(ChartIq, function (prev, next) { return _.isEqual(prev, next); });
